module.exports = __webpack_public_path__ + "img/team1.f6d69471.jpg";